module.exports = __webpack_public_path__ + "img/pic-two.2fddc2d6.png";